import { isBefore } from 'date-fns';

export const sortByStartDate = (a, b) =>
  isBefore(new Date(a.startDate), new Date(b.startDate)) ? -1 : 1;
